module.exports = __webpack_public_path__ + "img/HellerDieGlocken.2f4aa57d.svg";